module.exports = __webpack_public_path__ + "static/4c73ebfd-62b2-4625-917d-6b39ec26dd19-original.e3d1de8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/teardrop-sky-blue/4c73ebfd-62b2-4625-917d-6b39ec26dd19-original.jpg
// module id = 1251
// module chunks = 168707334958949